import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// "Are you sure?" before a job photo is removed
export const PhotoDeleteDialog = ({ open, onOpenChange, onConfirm, testId = "photo-delete-dialog" }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testId} className="border-zinc-800 bg-zinc-900 text-zinc-100">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this photo?</AlertDialogTitle>
        <AlertDialogDescription className="text-zinc-400">
          Are you sure you want to delete this image? It will be removed from the job for the office and the crew.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`} className="border-zinc-700 bg-transparent hover:bg-zinc-800">
          Keep photo
        </AlertDialogCancel>
        <AlertDialogAction
          data-testid={`${testId}-confirm`}
          onClick={onConfirm}
          className="bg-red-600 text-white hover:bg-red-500"
        >
          Delete photo
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
